export default __webpack_public_path__ + "static/media/movie.c89e218f.png";